export default "/images/882deb2e28db602b055463e4a507e101.png";